import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	setLoadSuccess: [],
	setLoadFail: ['error'],
	clearLoadError: [],
	loadDetails: ['load'],
	loadDetailsLoading: [],
	loadDetailsError: ['error'],
	cleanLoadDetails: [],
	loadId: ['id'],
	loadIdLoading: [''],
	loadIdClean: [''],
	getLoadListSuccess: [],
	loadAddOrder: ["order"],
	loadRemoveOrder: ["order"],
	loadCleanOrders: [],
	loadDelete: ['response'],
	loadAddOrderFromModal: ['response'],
	loadDeleteOrder:['response'],
	setLoadAddError:[''],
	setLoadAddSuccess:['']
	
});

//Reducer Handlers
const INITIAL_STATE = {
	error: [],
	loadDetails: null,
	loadDetailsLoading: false,
	loadId: null,
	loadIdLoading: false,
	orderlist: [],
	loadList: [],
	loadAddOrderFromModal: [12, 50],
	loadDelete: null,
	loadDeleteOrder: null,
	loadError: null,
	loadSuccess: null
};

const loadDetails = (state = INITIAL_STATE, action) => {
	return { ...state, loadDetails: action.payload, loadIdLoading: false }
}

const loadDetailsLoading = (state = INITIAL_STATE, action) => {
	return { ...state, loadIdLoading: true, loadDetails: null }
}

const loadDetailsError = (state = INITIAL_STATE, action) => {
	return { ...state, loadIdLoading: false, loadDetails: null }
}

const setLoadSuccess = (state = INITIAL_STATE, action) => {
	return { ...state, error: [], loadId: action.payload, loadIdLoading: false }
}

const setLoadFail = (state = INITIAL_STATE, action) => {
	return { ...state, error: [action.payload.message] }
}

const clearLoadFail = (state = INITIAL_STATE, action) => {

	return { ...state, error: [] }
}

const cleanLoadDetails = (state = INITIAL_STATE, action) => {
	return { ...state, loadDetails: null }
}

const loadId = (state = INITIAL_STATE, action) => {
	return { ...state, loadId: action.loadId, loadIdLoading: false }
};

const loadIdLoading = (state = INITIAL_STATE, action) => {
	return { ...state, loadIdLoading: true, loadId: null }
};

const loadIdClean = (state = INITIAL_STATE, action) => {
	return { ...state, loadIdLoading: true, loadId: null }
};

const getLoadListSuccess = (state = INITIAL_STATE, action) => {
	return { ...state, loadList: action.payload}
};

const add = (state = INITIAL_STATE, action) => {
	return { ...state, orderlist: [...state.orderlist, action.orderId] }
};

const remove = (state = INITIAL_STATE, action) => {
	return { ...state, orderlist: [...state.orderlist.filter(filteredOrder => JSON.stringify(filteredOrder) !== JSON.stringify(action.orderId))] };
}

const clean = (state = INITIAL_STATE, action) => {
	return { ...state, orderlist: [] }
}

const loadAddOrderFromModal = (state = INITIAL_STATE, action) => {
	return { ...state, loadAddOrder: action.payload }
};

const loadDeleteOrder = (state = INITIAL_STATE, action) => {
	return { ...state, loadDeleteOrder: action.payload }
 };

const loadDelete = (state = INITIAL_STATE, action) => {
	return { ...state, loadDelete: action.payload }
};

const setLoadAddError = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		loadError: {
			...action.payload 
		}
	}
}	

const setLoadAddSuccess = (state = INITIAL_STATE, action) => {
	return { 
		...state, 
		loadSuccess: {
			...action.payload
		}
	}
}	

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.SET_LOAD_SUCCESS]: setLoadSuccess,
	[Types.SET_LOAD_FAIL]: setLoadFail,
	[Types.CLEAR_LOAD_ERROR]: clearLoadFail,
	[Types.LOAD_DETAILS]: loadDetails,
	[Types.LOAD_DETAILS_LOADING]: loadDetailsLoading,
	[Types.LOAD_DETAILS_ERROR]: loadDetailsError,
	[Types.CLEAN_LOAD_DETAILS]: cleanLoadDetails,
	[Types.LOAD_ID]: loadId,
	[Types.LOAD_ID_LOADING]: loadIdLoading,
	[Types.LOAD_ID_CLEAN]: loadIdClean,
	[Types.GET_LOAD_LIST_SUCCESS]: getLoadListSuccess,
	[Types.LOAD_ADD_ORDER]: add,
	[Types.LOAD_REMOVE_ORDER]: remove,
	[Types.LOAD_CLEAN_ORDERS]: clean,
	[Types.LOAD_DELETE]: loadDelete,
	[Types.LOAD_ADD_ORDER_FROM_MODAL]: loadAddOrderFromModal,
	[Types.LOAD_DELETE_ORDER]: loadDeleteOrder,
	[Types.SET_LOAD_ADD_ERROR]: setLoadAddError,
	[Types.SET_LOAD_ADD_SUCCESS]: setLoadAddSuccess
});
